<template>
  <div class="vue-modal-dialog-mask white-modal" :class="$style.container">
    <div class="vue-modal-dialog-content">
      <header>
        Invite Notetaker
        <button type="button" @click="close" class="close" data-dismiss="modal" aria-hidden="true" :style="'padding: 15px;'">
          <FontAwesomeIcon :icon="faTimes" />
        </button>
      </header>

      <p :class="$style.subheader">
        If you have a live meeting running, copy and paste the meeting/invite
        link to capture the meeting in Jiminny
        <a
          href="https://help.jiminny.com/supporting-instant-meetings/instantly-invite-jiminny-into-your-meetings"
          target="_blank"
          v-tippy="{
            placement: 'right',
            content: 'Open knowledge base (in a new window)'
          }">
          <font-awesome-icon :icon="faQuestionCircle" />
        </a>
      </p>

      <form @submit.prevent="onSubmit">
        <div>
          <textarea
            :class="$style.textarea"
            name="url"
            autocomplete="off"
            v-model="url"
            v-focus
            v-validate="'required|min:2'"
            placeholder="URL"
            rows="5"
            ></textarea>
        </div>

        <footer>
          <button type="submit" :class="$style.button" :disabled="busy">Invite</button>
        </footer>
       </form>
    </div>
  </div>
</template>

<script>
import InputLayout from '@/components/shared/SearchContacts/shared/InputLayout'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import axios from 'axios'
import { jiminnyHost } from '@/helpers/region'
import * as Notifications from './notifications'

export default {
  components: {
    InputLayout,
    FontAwesomeIcon
  },
  data () {
    return {
      url: '',
      faQuestionCircle,
      faTimes,
      busy: false
    }
  },
  mounted () {
    const query = this.$route.query

    if (query.instant_invite) {
      this.url = query.instant_invite

      this.$router.push(this.$route.path)

      this.sendInvite()

      this.close()
    }
  },
  methods: {
    onSubmit () {
      this.sendInvite()
    },
    async sendInvite () {
      if (this.url.length > 2) {
        this.busy = true

        try {
          const response = await axios.post(`${jiminnyHost()}/api/v1/instant-meeting/start`, {
            url: this.url
          })

          this.close()
          Notifications.successNotification(response.data).show()
        } catch (error) {
          this.handleErrors(error.response.data)
        }

        this.busy = false
      }
    },
    handleErrors (response) {
      if (
        response.error &&
        response.error.http_code &&
        response.error.http_code === 400
      ) {
        Notifications.errorNotification(response.error).show()
      } else {
        if (response.error) {
          Notifications.errorNotification(response).show()
        }

        if (response.errors) {
          Notifications.errorNotification({message: response.errors.url[0]}).show()
        } else if (!response.error) {
          Notifications.errorNotification({message: 'Something went wrong. Please contact support.'}).show()
        }
      }
    },
    close () {
      this.$close(true)
    }
  }
}
</script>

<style module lang="less" src="./InstantInviteModal.less"></style>



// WEBPACK FOOTER //
// InstantInviteModal.vue?474748ee